import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchInstructorEntitlements } from './services/instructorEntitlementsApi';

// Payment confirmation only. The Stripe webhook (Spring backend) records the
// subscription and cancels any previous one — this page never writes state.
const SuccessPage = () => {
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    ['sessionId', 'packageIdplan', 'packagePrice', 'name'].forEach((key) =>
      localStorage.removeItem(key),
    );
    if (userId) {
      // Refresh cached entitlements so the new tier shows immediately.
      fetchInstructorEntitlements(userId).catch(() => {});
    }
  }, [userId]);

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 14,
      maxWidth: 480, margin: '60px auto', padding: 32,
      background: 'oklch(1 0 0)', border: '1px solid transparent', borderRadius: 22,
      boxShadow: '0 1px 2px rgba(17,20,38,.04), 0 6px 16px -4px rgba(17,20,38,.10)',
      fontFamily: '"Hanken Grotesk", system-ui, sans-serif',
    }}>
      <h1 style={{ fontFamily: '"Hanken Grotesk", system-ui, sans-serif', fontSize: 22, fontWeight: 760, letterSpacing: '-.02em', color: 'oklch(0.62 0.15 158)', margin: 0 }}>Payment successful</h1>
      <p style={{ fontSize: 13.5, color: 'oklch(0.52 0.018 268)', margin: 0 }}>Your payment was completed successfully.</p>
      <Link to="/Portal/Instructor" style={{
        marginTop: 8, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        height: 34, padding: '0 16px', borderRadius: 12,
        background: 'oklch(0.22 0.008 270)', color: '#fff', fontSize: 11.5, fontWeight: 650, textDecoration: 'none',
      }}>Go to Dashboard</Link>
    </div>
  );
};

export default SuccessPage;
